<template>
    <div class="id57-bg" style="width: 600px; margin:0 auto; position: relative; border: 3px solid #efefef; padding: 20px;">
        <div style="text-align: center; font-size: 26px; color: #000; font-weight: bold;">Опрос:</div>
        <div style="font-size: 16px; margin-top: 20px;">
            Некоторые современные автомобили способны довести вас до дома без участия человека при включенной функции автопилота.
            Как вы считаете, поможет ли это уменьшить количество ДТП?
        </div>
        <br/>
        <div>
            <label>
                <input type="radio" name="radio" v-model="radio" value="Да, это должно помочь снизить количество ДТП" @change="onChange"/>
                Да, это должно помочь снизить количество ДТП
            </label>
            <br/>
            <label>
                <input type="radio" name="radio" v-model="radio" value="Нет, это не поможет" @change="onChange"/>
                Нет, это не поможет
            </label>
        </div>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                radio: ''
            }
        },
        methods: {
            onChange () {
                this.$emit('input', this.radio)
            }
        }
    }
</script>
<style scoped>
    .id57-bg {
        background: url('bg.png') repeat;
    }
</style>
